function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.35 1l10.975 13.864M15.204 5.965c-3.54-3.54-10.618-3.54-14.157 0M12.373 10.39c-2.123-2.301-6.37-2.301-8.494 0",
  stroke: "#5D5E5E",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8.125",
  cy: "14.46",
  r: "1.416",
  fill: "#5D5E5E"
})));